module.exports = __webpack_public_path__ + "img/icons8-warning-shield-16.3a00816f.png";